import { DatePicker } from "@/features/projects/filter/dateFilter/DatePicker";
import {
  type DateFilterOption,
  dateUpdateAction,
} from "@/features/projects/filter/dateFilter/utils";
import { type ProjectFilterActions } from "@/features/projects/filter/projectFilterReducer";
import { AccordionItem } from "@repo/skapa";
import { useTranslation } from "@repo/translation";
import { localizeDate } from "@repo/ui";
import { type Locale } from "date-fns";
import { useState } from "react";
import { useUnmount } from "usehooks-ts";

function getDateSubtitle(
  date: (Date | undefined)[] | undefined,
  dateFnsLocale?: Locale
): string | undefined {
  if (!date || date.length === 0) {
    return undefined;
  }

  return `${date?.[0] ? localizeDate(date?.[0], dateFnsLocale) : "~"} - ${
    date?.[1] ? localizeDate(date?.[1], dateFnsLocale) : "~"
  }`;
}

interface DateFilterAccordionItemProps {
  open: boolean;
  dates: (Date | undefined)[];
  actions: ProjectFilterActions;
  option: DateFilterOption;
  id: string;
  title: string;
  allowFutureDates?: boolean;
}

export const DateFilterAccordionItem = ({
  dates,
  actions,
  open,
  option,
  id,
  title,
  allowFutureDates = false,
}: DateFilterAccordionItemProps) => {
  const [dateRange, setDateRange] = useState(dates);
  const { dateFnsLocale } = useTranslation();

  useUnmount(() => {
    dateUpdateAction(dateRange, actions, option);
  });

  const handleClose = (isOpen: boolean) => {
    if (!isOpen) {
      dateUpdateAction(dateRange, actions, option);
    }
  };

  return (
    <AccordionItem
      id={id}
      title={title}
      subtitle={getDateSubtitle(dateRange, dateFnsLocale)}
      open={open}
      onTransitionEnd={(_e, isOpen) => handleClose(isOpen)}
    >
      <DatePicker
        createdDate={dateRange}
        onChange={setDateRange}
        allowFutureDates={allowFutureDates}
      />
    </AccordionItem>
  );
};
